<div class="row no-gutters remove-margin-top">
  <div class="col-12">
    <div
      class="image-container top-image"
      [routerLink]="'/products'"
      style="background-image: url('/assets/ref-start-page/REF_Models_Hair_Identities_Champagne_1074_20191127_3.jpg')"
    >
      <div class="image-text text-primary w-100 text-uppercase" translate>PROMOTIONS</div>
    </div>
  </div>
</div>
<div class="row no-gutters">
  <div class="col-12 col-md-6 col-lg-4">
    <div
      class="image-container"
      [routerLink]="'/products'"
      style="background-image: url('/assets/ref-start-page/REF_Lifestyle_Bali_Fabian_Wester-10.jpg')"
    >
      <div class="image-text text-primary w-100 text-uppercase" translate>CARE</div>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    <div
      class="image-container"
      [routerLink]="'/products'"
      style="background-image: url('/assets/ref-start-page/REF_Lifestyle_Bali_Fabian_Wester-57.jpg')"
    >
      <div class="image-text text-primary w-100 text-uppercase" translate>STYLING</div>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    <div
      class="image-container"
      [routerLink]="'/products'"
      style="background-image: url('/assets/ref-start-page/REF_Stillife_Kurppa_Hosk(2016)-21.jpg')"
    >
      <div class="image-text text-primary w-100 text-uppercase" translate>PROFESSIONAL</div>
    </div>
  </div>
</div>
